import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { firestoreDB } from "../config/firebase_config";
import { StoreOffer } from "../types/offer";

/**
 * Fetch offers for a specific store from Firestore
 */
export async function fetchOffersByStoreId(storeId: string): Promise<StoreOffer[]> {
    try {
        const offersRef = collection(firestoreDB, "StoreOffers");
        const q = query(
            offersRef,
            where("restId", "==", storeId)
        );


        const querySnapshot = await getDocs(q);
        const offers: StoreOffer[] = [];

        console.log({ querySnapshot })
        console.log(`[OfferService] Fetching offers for restId: ${storeId}. Found ${querySnapshot.size} matches.`);

        querySnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            console.log(`[OfferService] Offer doc ${docSnap.id}:`, data);

            // Resilience: handle boolean or string "true"
            const isActive = data.isActive === true || data.isActive === "true" || data.isActive === 1;

            // Resilience: case-insensitive type check
            const offerType = data.type?.toString().toUpperCase();

            if (isActive && (offerType === "PAYBILL" || offerType === "BOTH")) {
                offers.push({
                    id: docSnap.id,
                    ...data
                } as StoreOffer);
            }
        });

        console.log(`[OfferService] Returning ${offers.length} valid offers.`);
        return offers;
    } catch (error) {
        console.error("Error fetching store offers:", error);
        return [];
    }
}

/**
 * Fetch all active offers from Firestore
 */
export async function fetchAllActiveOffers(): Promise<StoreOffer[]> {
    try {
        const offersRef = collection(firestoreDB, "StoreOffers");
        const q = query(offersRef, where("isActive", "==", true));

        const querySnapshot = await getDocs(q);
        const offers: StoreOffer[] = [];

        querySnapshot.forEach((doc) => {
            offers.push({
                id: doc.id,
                ...doc.data()
            } as StoreOffer);
        });

        return offers;
    } catch (error) {
        console.error("Error fetching all active offers:", error);
        return [];
    }
}
